import axios from "@/plugins/axios";

import schedule from "./schedule";

let url = "/api/v1/person/meetings";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    schedule,
};
